<template>
  <b-modal
    id="modal-store-min-delivery-minutes"
    v-model="showModal"
    :title="$t('Tempos de entrega')"
    no-close-on-backdrop
    centered
    size="sm"
  >
    <FormulateForm
      ref="form"
      @submit="onConfirm"
    >
      <b-row>
        <b-col md="12">
          <FormulateInput
            id="store-min-delivery-minutes-store"
            :value="storeName"
            :label="$tc('STORE.NAME')"
            type="label"
          />
        </b-col>
        <b-col md="12">
          <FormulateInput
            id="store-min-delivery-minutes-value"
            v-model.number="minutes"
            name="minDeliveryScheduleMinutes"
            type="number"
            class="required"
            min="1"
            max="1440"
            step="1"
            validation="required|number|min:1|max:1440"
            :validation-messages="{
              required: $t('STORE.VALIDATION_ERROR.MIN_DELIVERY_SCHEDULE_MINUTES_OUT_OF_RANGE'),
              number: $t('STORE.VALIDATION_ERROR.MIN_DELIVERY_SCHEDULE_MINUTES_OUT_OF_RANGE'),
              min: $t('STORE.VALIDATION_ERROR.MIN_DELIVERY_SCHEDULE_MINUTES_OUT_OF_RANGE'),
              max: $t('STORE.VALIDATION_ERROR.MIN_DELIVERY_SCHEDULE_MINUTES_OUT_OF_RANGE'),
            }"
            :label="$t('Tempo mínimo (min)')"
            :instruction="
              $t(
                'Tempo, em minutos, entre o pedido e a entrega. Valida o agendamento e define a janela do acionamento automático.'
              )
            "
          />
        </b-col>
        <b-col md="12">
          <FormulateInput
            id="store-lending-installation-minutes-value"
            v-model.number="lendingInstallationMinutes"
            name="lendingInstallationMinutes"
            type="number"
            class="required"
            min="15"
            max="480"
            step="5"
            validation="required|number|min:15|max:480|multipleOf5"
            :validation-messages="{
              required: $t('STORE.VALIDATION_ERROR.INVALID_LENDING_INSTALLATION_MINUTES'),
              number: $t('STORE.VALIDATION_ERROR.INVALID_LENDING_INSTALLATION_MINUTES'),
              min: $t('STORE.VALIDATION_ERROR.INVALID_LENDING_INSTALLATION_MINUTES'),
              max: $t('STORE.VALIDATION_ERROR.INVALID_LENDING_INSTALLATION_MINUTES'),
              multipleOf5: $t('STORE.VALIDATION_ERROR.INVALID_LENDING_INSTALLATION_MINUTES'),
            }"
            :validation-rules="{ multipleOf5 }"
            :label="$t('Tempo de instalação do comodato (min)')"
            :instruction="
              $t(
                'Tempo, em minutos, de uma entrega de chope/comodato. Define o tamanho dos horários da agenda de instalação.'
              )
            "
          />
        </b-col>
      </b-row>
    </FormulateForm>

    <template #modal-footer>
      <e-button
        id="modal-store-min-delivery-minutes-btn_cancel"
        class="mr-1"
        variant="outline-primary"
        :text="$t('Cancelar')"
        @click="hideModal"
      />
      <e-button
        id="modal-store-min-delivery-minutes-btn_confirm"
        variant="primary"
        :text="$t('Salvar')"
        :busy="saving"
        @click="onConfirm"
      />
    </template>
  </b-modal>
</template>

<script>
import { BModal, BRow, BCol } from 'bootstrap-vue'
import { mapActions } from 'vuex'
import EButton from '@/views/components/EButton.vue'

/**
 * Edição rápida do tempo mínimo de entrega e do tempo de instalação do comodato de UMA loja,
 * aberta pela coluna de ações da listagem. Grava pelo endpoint dedicado
 * (PUT /stores/{id}/min-delivery-schedule-minutes), que altera só esses campos — a manutenção
 * completa da loja continua sendo o caminho para os demais.
 * Emite `saved` para a listagem recarregar.
 */
export default {
  components: { BModal, BRow, BCol, EButton },

  data() {
    return {
      showModal: false,
      saving: false,
      storeId: null,
      storeName: '',
      minutes: null,
      lendingInstallationMinutes: null,
    }
  },

  methods: {
    ...mapActions('pages/store/storeMaintain', ['setStoreMinDeliveryScheduleMinutes']),

    // O tempo de instalação do comodato anda de 5 em 5 minutos (mesma regra do backend).
    multipleOf5({ value }) {
      if (value === '' || value === null || value === undefined) return true
      return Number(value) % 5 === 0
    },

    show(store) {
      this.storeId = store.id
      this.storeName = store.tradingName || store.companyName || ''
      this.minutes = store.minDeliveryScheduleMinutes ?? 40
      this.lendingInstallationMinutes = store.lendingInstallationMinutes ?? 60
      this.showModal = true
    },

    hideModal() {
      this.showModal = false
    },

    async onConfirm() {
      if (!this.$refs.form.isValid) {
        this.showInvalidDataMessage()
        return
      }

      try {
        this.saving = true
        await this.setStoreMinDeliveryScheduleMinutes({
          storeId: this.storeId,
          minDeliveryScheduleMinutes: this.minutes,
          lendingInstallationMinutes: this.lendingInstallationMinutes,
        })
        this.showSuccess({ message: this.$t('Tempos de entrega atualizados.') })
        this.hideModal()
        this.$emit('saved')
      } catch (error) {
        this.showGenericError({ error })
      } finally {
        this.saving = false
      }
    },
  },
}
</script>
